var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.5,
    height: 18,
    viewBox: "0 0 22.5 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.375,18h-3.69l-.611-1.837a2.248,2.248,0,0,0-2.135-1.538H18.811a2.248,2.248,0,0,0-2.135,1.539L16.065,18h-3.69a2.252,2.252,0,0,0-2.25,2.25V30.375a2.252,2.252,0,0,0,2.25,2.25h18a2.252,2.252,0,0,0,2.25-2.25V20.25A2.252,2.252,0,0,0,30.375,18Zm-9,11.25a4.5,4.5,0,1,1,4.5-4.5,4.5,4.5,0,0,1-4.5,4.5Z",
    transform: "translate(-10.125 -14.625)",
    fill: "#707070"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.a3830fa897eb9c81da072740ab16b603.svg";
export { ForwardRef as ReactComponent };